const admin_page = {}

export default admin_page
